import styled from "styled-components";

export const CommerceContentWrapper = styled.section`
	width: 100%;
	min-height: 100vh;
	display: flex;
	flex-direction: column;
	padding: 15vh 0px;

	.hero {
		width: 100%;
		height: 40vh;
		position: relative;
		z-index: 1;
		.hero_text {
			width: 440px;
			height: 100px;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			position: absolute;
			left: calc(50% - 225px);
			bottom: 20px;
			z-index: 20;
			h2,
			h1 {
				color: ${(props) => props.theme.color.white};
				font-weight: ${(props) => props.theme.fontWeight.light};
			}
			h2 {
				font-family: ${(props) => props.theme.font.text};
				font-size: 14px;
			}
			h1 {
				font-family: ${(props) => props.theme.font.title};
				font-size: 32px;
			}
		}
	}
	h3 {
		margin-top: 40px;
		font-family: ${(props) => props.theme.font.text};
		font-size: 14px;
		font-weight: ${(props) => props.theme.fontWeight.light};
		text-align: center;
		width: 70%;
		align-self: center;
	}

	label,
	p {
		width: 100%;
		//text-transform: uppercase;
		text-align: left;
		font-size: 13px;
		font-weight: ${(props) => props.theme.fontWeight.light};
		font-family: ${(props) => props.theme.font.text};
		margin-left: 10px;
	}
	.success {
		width: 70%;
		align-self: center;
		display: flex;
		flex-direction: column;
		align-items: center;
		button {
			width: 300px;
			height: 40px;
			margin-top: 30px;
		}
	}
	button {
		width: 100%;
		height: 50px;
		background: ${(props) => props.theme.color.darkGreen};
		color: ${(props) => props.theme.color.white};
		font-family: ${(props) => props.theme.font.text};
		text-transform: uppercase;
		font-weight: ${(props) => props.theme.fontWeight.light};
		border-radius: 10px;
		cursor: pointer;
		transition: 0.3s;
		border: none;

		&:hover {
			background: ${(props) => props.theme.color.lightGreen};
			color: ${(props) => props.theme.color.black};
			font-weight: ${(props) => props.theme.fontWeight.bold};
		}
	}

	form {
		width: 70%;
		margin-top: 50px;
		align-self: center;

		.top_inputs {
			display: flex;
			justify-content: space-between;
			width: 100%;
			.right,
			.left {
				width: 48%;
			}
		}
		.error {
			color: red;
			font-size: 13px;
			font-weight: ${(props) => props.theme.fontWeight.light};
			font-family: ${(props) => props.theme.font.text};
		}
		.lower_inputs {
			width: 100%;
			display: flex;
			flex-direction: column;
		}
		input {
			width: 100%;
			height: 50px;
			box-shadow: 0px 2px 11px 0px #313b161f;
			border: 0.5px solid #cbcccd;
			margin: 15px 0px;
			font-weight: ${(props) => props.theme.fontWeight.light};
			font-family: ${(props) => props.theme.font.text};
			padding-left: 15px;
			border-radius: 10px;
			outline: none;
			&::placeholder {
				color: ${(props) => props.theme.color.lightGreen};
				font-size: 13px;
			}
			&:focus {
				outline: 1px solid #b4b4b5;
			}
		}
		label {
			margin-top: 20px;

			font-size: 16px;
			font-variant: small-caps;
		}
		.checkbox_container {
			display: flex;
			align-items: center;
			margin: 10px 0px;
			input[type="checkbox"] {
				height: 20px;
				width: 20px;
			}
			label {
				color: ${(props) => props.theme.color.lightGreen};
				margin-top: 0px;
			}
			&:not(:first-of-type) {
				margin-bottom: 50px;
			}
		}
		p {
			margin: 40px 0px;
		}
	}

	@media screen and (max-width: 769px) {
		.hero {
			.hero_text {
				width: 300px;
				left: calc(50% - 150px);
				h1 {
					font-size: 25px;
					text-align: center;
				}
			}
		}
		h3 {
			width: 90%;
		}
		form {
			width: 90%;
			margin-top: 30px;
			.top_inputs {
				flex-direction: column;
				.right,
				.left {
					width: 100%;
				}
			}
		}
	}
`;
